import React from 'react';
import { X, AlertTriangle, User } from 'lucide-react';
import { Loan } from '../types';
interface CloseEscalationModalProps {
  isOpen: boolean;
  onClose: () => void;
  loan: Loan | null;
  onConfirm: () => void;
}
export function CloseEscalationModal({
  isOpen,
  onClose,
  loan,
  onConfirm
}: CloseEscalationModalProps) {
  if (!isOpen || !loan) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-16">
      <div className="absolute inset-0 bg-gray-900/40 backdrop-blur-sm" onClick={onClose} data-id="element-17"></div>

      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative z-10" data-id="element-18">
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-19">
          <div className="flex items-center gap-3" data-id="element-20">
            <div className="bg-amber-50 text-amber-600 p-2 rounded-xl" data-id="element-21">
              <AlertTriangle className="w-5 h-5" data-id="element-22" />
            </div>
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-23">
              Close Escalation
            </h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-1.5 rounded-lg transition-colors" data-id="element-24">
            <X className="w-5 h-5" data-id="element-25" />
          </button>
        </div>

        <div className="p-6" data-id="element-26">
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-5" data-id="element-27">
            <p className="text-sm font-medium text-gray-900" data-id="element-28">
              {loan.borrowerName}
            </p>
            <p className="text-xs text-gray-500 mt-0.5" data-id="element-29">
              {loan.loanName} · #{loan.loanId}
            </p>
          </div>

          <div className="bg-amber-50 border border-amber-100 rounded-xl p-4 mb-5" data-id="element-30">
            <p className="text-sm text-amber-800 leading-relaxed" data-id="element-31">
              Closing this escalation will remove it from the queue. The loan
              will remain assigned to the current LOA and Processor — no
              reassignment will be made.
            </p>
          </div>

          <div className="space-y-2.5" data-id="element-32">
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-33">
              Current Assignment
            </p>
            <div className="bg-gray-50 rounded-xl border border-gray-100 divide-y divide-gray-100" data-id="element-34">
              <div className="flex items-center justify-between px-4 py-3" data-id="element-35">
                <div className="flex items-center gap-2 text-gray-500" data-id="element-36">
                  <User className="w-4 h-4" data-id="element-37" />
                  <span className="text-sm" data-id="element-38">Processor</span>
                </div>
                <span className="text-sm font-medium text-gray-900" data-id="element-39">
                  {loan.processor}
                </span>
              </div>
              <div className="flex items-center justify-between px-4 py-3" data-id="element-40">
                <div className="flex items-center gap-2 text-gray-500" data-id="element-41">
                  <User className="w-4 h-4" data-id="element-42" />
                  <span className="text-sm" data-id="element-43">LOA</span>
                </div>
                <span className="text-sm font-medium text-gray-900" data-id="element-44">
                  {loan.loa}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-end gap-3 bg-gray-50/50 rounded-b-2xl" data-id="element-45">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-46">
            Cancel
          </button>
          <button onClick={onConfirm} className="px-5 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors shadow-sm" data-id="element-47">
            Close Escalation
          </button>
        </div>
      </div>
    </div>;
}